import { PipeTransform, Pipe } from '@angular/core';

@Pipe({name: 'keys'})
export class ObjKeysPipe implements PipeTransform {
  transform(value: any, keyAndValue: boolean = false): any {
    if(!keyAndValue)  return Object.keys(value);
    else {
      let obj = [];
      for(let key in value){
        obj.push({ key: key, value: value[key]});
      }
      return obj;
      
    }
  }
}


// WEBPACK FOOTER //
// ./src/pipes/objKeys.ts